/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.logo-grid {
  @apply grid  grid-cols-3  gap-32px w-full items-center md:gap-64px;
}
.logo-layout-6 {
  @apply sm:grid-cols-6 !important;
}

.logo-layout-5 {
  @apply md:grid-cols-5 !important;
}

@media (max-width: 1000px) { /* Tailwind's sm breakpoint for tablet */
  .logo-layout-5 {
    @apply grid grid-cols-3;
  }
  .logo-layout-5 .grid-item:nth-last-child(-n+2) { /* targets the last two .grid-item elements */
    @apply col-start-1 col-end-3 self-center;
  }
}
.logo-layout-4 {
  @apply grid-cols-2 sm:grid-cols-4 !important;
}

.logo-layout-3 {
  @apply sm:grid-cols-3 !important;
}

.logo-layout-2 {
  @apply sm:grid-cols-2 !important;
}

.logo-layout-1 {
  @apply sm:grid-cols-1 !important;
}

.grid-item {
  @apply col-span-1 mx-auto ;
}

.logo-container {
  @apply flex justify-center items-center aspect-square w-full max-w-[250px] max-h-[250px];
}

/* Animations */
@keyframes fade-in {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 0;

  }
}

.overlay1, .overlay2, .overlay3, .overlay4{
  @apply absolute bg-white w-full h-full top-0 left-0 z-20 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
}

.logo-grid.animate .overlay1 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.logo-grid.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

.logo-grid.animate .overlay3 {
  animation-name: fade-in;
  animation-delay: .30s;
}

.logo-grid.animate .overlay4 {
  animation-name: fade-in;
  animation-delay: .45s;
}

.logo-grid.animate .overlay5 {
  animation-name: fade-in;
  animation-delay: .60s;
}

.logo-grid.animate .overlay6 {
  animation-name: fade-in;
  animation-delay: .75s;
}
